import { getLockedMyVendorAccessTooltip } from "./myVendorsRequestAccess";

/**
 * Resolves Status Dashboard "View Details" / row-click navigation for VQQ vs VQA.
 * Cross-family managers can see the other tab's rows but must not open details
 * (ProtectedRoute would bounce them / allowMyVendorsViewAccess would leak VQQ).
 *
 * @param {'VQQ'|'VQA'} family
 * @param {{ canOpenVqq: boolean, canOpenVqa: boolean, vqqId?: string|null, vqaId?: string|null }} options
 * @returns {{ type: 'navigate', path: string } | { type: 'locked', message: string } | { type: 'noop' }}
 */
export function resolveStatusDashboardViewDetails(family, options) {
  const { canOpenVqq, canOpenVqa, vqqId, vqaId } = options || {};
  const canOpen = family === "VQA" ? canOpenVqa : canOpenVqq;

  if (!canOpen) {
    return {
      type: "locked",
      message: getLockedMyVendorAccessTooltip(family, "open"),
    };
  }

  if (family === "VQA") {
    if (!vqaId) return { type: "noop" };
    return { type: "navigate", path: `/Assessment/${vqaId}/Details` };
  }

  if (!vqqId) return { type: "noop" };
  return { type: "navigate", path: `/RFI/${vqqId}/Details` };
}

/**
 * Applies resolveStatusDashboardViewDetails via navigate / onLocked callbacks.
 * @returns {boolean} true when navigation ran
 */
export function runStatusDashboardViewDetails(family, options, handlers = {}) {
  const { navigate, onLocked } = handlers;
  const result = resolveStatusDashboardViewDetails(family, options);

  if (result.type === "navigate") {
    navigate?.(result.path);
    return true;
  }
  if (result.type === "locked") {
    onLocked?.(result.message);
  }
  return false;
}
